<template>
    <v-row justify="center">
        <v-btn
                color="primary"
                dark
                @click.stop="dialog = true"
        >
            Export Vcard
        </v-btn>

        <v-dialog
                v-model="dialog"
                max-width="400"
        >
            <v-card>
                <v-card-title class="headline">Vcard: {{ vcard.name }} {{ vcard.surname }}</v-card-title>

                <v-card-text center v-if="vcard">
                    <QrCode :url="vcard.print()"></QrCode>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="blue darken-1"
                            text
                            @click="download"
                    >
                        Download vcard
                    </v-btn>

                    <v-btn
                            color="green darken-1"
                            text
                            @click="dialog = false"
                    >
                        close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>


<script>

    import Vcard from "../../../models/vcard";
    import QrCode from "./QrCode";

    export default {
        name: "VcardComponent",
        components: {QrCode},
        data: () => ({
            dialog: false,
            vcard: null,
        }),
        mounted() {
            // load vcard
            console.log("vcard commponent mounted");
            console.log(this.contact)
            if (this.contact) {
                let vcard = new Vcard();
                vcard.name = this.contact.first_name ;
                vcard.surname = this.contact.surname ;
                vcard.mail = this.contact.email;
                vcard.phone_pro = this.contact.phone_number;
                vcard.address = this.contact.address;

                let _vcard = vcard.print();
                console.log(_vcard);

                this.vcard = vcard;





            }else{
                return null
            }


        },

        props: {
            contact: Object,
        },
        methods: {
            download: function () {
                function download(filename, text) {
                    var element = document.createElement('a');
                    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
                    element.setAttribute('download', filename);

                    element.style.display = 'none';
                    document.body.appendChild(element);

                    element.click();

                    document.body.removeChild(element);
                }

                download('qd-contact.vcf',this.vcard.print());


            }
        }
        /*
        computed: {
            formatedVcard: function(){
                if (this.contact) {
                    let vcard = new Vcard();
                    vcard.name = this.contact.name | null;
                    vcard.surname = this.contact.surname | null;
                    vcard.mail = this.contact.email | null;
                    vcard.phone = this.contact.phone_number | null;
                    vcard.name = this.contact.name | null;

                    let _vcard = vcard.print();
                    console.log(_vcard);
                    return _vcard;



                }else{
                    return null
                }

            }


        }*/
    }
</script>
